import axios from 'axios'

export const getOrganicRankManagementReq = ({ accountID, channelID, productID }) =>
  axios.get(`/organicRankManagement/${accountID}/${channelID}/${productID}`)

export const patchOrganicRankManagementReq = ({ accountID, channelID, productID, data }) =>
  axios.patch(`/organicRankManagement/${accountID}/${channelID}/${productID}`, data)

export const getAvailableOrganicRankManagementReq = ({ accountID, channelID, productID }) =>
  axios.get(`/organicRankManagement/${accountID}/${channelID}/${productID}/getAvailable`)
